let routes = [
  {
    path: "/selfscanning",
    name: "Selfscanning",
    component: () => import("@/views/selfscanning/Selfscanning.vue")
  }
];

export default routes;
